<template>
  <div class="mh bg-main uploadTemp">
    <tip tips="为保证您的图片正常上传，请将您要上传的证件图片控制在10M以内，若图片过大，上传时请耐心等待！"/>
    <div class="p10">
      <card-wrap title="制作个人证件照片">
        <div class="flexBox around p30-0">
          <div class="demo">
            <img src="@/assets/img/yangli-p@2x.png" alt="" />
          </div>
          <div class="uploadDemo" @click="uploadDemo">
            <img v-if="photoShow" :src="photoShow" alt="" style="display: block;width: 100%;height: 105px;object-fit:fill;">
            <div v-else class="showIcon">
              <img src="@/assets/img/xiangji@2x.png" alt="" />
              <div>小程序采集照片</div>
            </div>
          </div>
        </div>
      </card-wrap>
      <card-wrap class="mt8" title="照片要求">
        <div class="tips-wrap mt10">
          <div>1.蓝色背景图片</div>
          <div>2.图像大小在30K-900K之间</div>
          <div>3.图片要求为150（宽） x 210（高）像素</div>
          <div>
            建议：请按指定要求上传
          </div>
        </div>
      </card-wrap>
    </div>
    <div class="next">
      <van-button type="info" block class="nextBtn" @click="clickSubmit">返回</van-button>
      <van-button type="info" block class="nextBtn" @click="clickBackBtn" v-if="!Boolean($route.query.disabled)">保存并返回</van-button>
     
    </div>
    <van-action-sheet v-model="showMini" title="">
      <div class="actionBox">
        <div class="miniText">国开专用图片采集小程序</div>
        <img src="@/assets/img/miniP1.jpg" alt="">
        <van-list>
          <van-cell>
            <div class="miniText">长安识别二维码，开始采集照片</div>
          </van-cell>
          <van-cell title="关闭" @click="showMini = false" />
          <van-cell title="已完成采集" @click="getMiniPhoto"/>
        </van-list>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>
import tip from "./component/tip.vue";
import cardWrap from "./component/cardWrap.vue";
import {getPhotosByIdentityNum} from '@/api/home'
import {getFileUrl} from "@/api/common/index"// 上传
export default {
  name: "UploadTemp",
  components: {tip,cardWrap},
  data() {
    return {
      showMini: false,
      photoShow: "",
      photo: "",
      id: "",
      identityNum: '',
    };
  },
  created() {
    this.initData()
  },
  watch: {
    $route(val) {
      if (val.path == '/uploadTemp') {
        this.initData()
      }
    }
  },
  methods: {
    initData() {
      this.photo = this.$store.state.photo
      this.identityNum = this.$route.query.identityNum
      // this.identityNum = '141029199005120044' // 测试数据
      if (this.photo) { // 上次照片
        getFileUrl({objectKey: this.photo}).then(datas=>{
          this.photoShow = datas
        })
      }
    },
    // 点击保存并返回按钮
    clickBackBtn() {
      if (!this.photoShow) {
        this.$toast({
          message: "请上传个人证件照",
          position: "top",
        });
        return;
      }
      this.$store.commit('setPhoto', this.photo);
      this.$router.back()
    },
    // 返回
    clickSubmit() {
      this.$store.commit('setPhoto', this.photo);
      this.$router.back()
      
    },
    uploadDemo() {
      if (Boolean(this.$route.query.disabled)) {
        return
      }
      this.showMini = true

    },
    // 完成采集
    getMiniPhoto() {
      if (!this.identityNum) {
        this.$toast({
          message: "请先完善信息",
          position: "top",
        });
        return
      }
      getPhotosByIdentityNum({identityNum: this.identityNum}).then(res=>{
        this.photo = res
        getFileUrl({objectKey: res}).then(datas=>{
          this.photoShow = datas
          this.showMini = false
        })
      }).catch(err=>{
        this.showMini = false
      })
    }
  }
};
</script>
<style scoped>
.uploadTemp {
  padding-bottom: 60px;
}
.tips-wrap {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
.around {
  justify-content: space-around;
}
.demo {
  width: 75px;
  position: relative;
}
.demo::after {
  position: absolute;
  content: "";
  width: 26px;
  height: 22px;
  background: url("../../assets/img/yangli@2x.png") no-repeat top;
  background-size: cover;
  right: 0;
  bottom: 0;
}
.demo img {
  display: block;
  width: 100%;
}
.uploadDemo {
	padding: 0;
  width: 75px;
  height: 105px;
  position: relative;
  background: url("../../assets/img/person@2x.png") no-repeat bottom;
  background-size: contain;
}
.showIcon {
	padding-top: 60%;
	text-align: center;
}
.showIcon img {
  display: block;
  width: 20px;
	margin: 0 auto;
}
.showIcon div {
  font-size: 12px;
  font-weight: 400;
  color: #d62d27;
  width: 70px;
  margin-top: 10px;
}
.actionBox {
  padding: 20px;
  text-align: center;
}
.actionBox img {
  display: block;
  max-width: 80%;
  margin: 10px auto;
}
.miniText {
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.miniAction {
  cursor: pointer;
}
.uploader {
  position: relative;
}
.uploader::before {
  position: absolute;
  left: -8px;
  color: #ee0a24;
  font-size: 14px;
  content: '*';
}

.next {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: #fff;
}
.next .nextBtn {
  background-color: red;
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
}
.next .nextBtn:nth-child(1){
  margin-right: 10px;
  background-color: #fff;
  color: red;
  border: 1px solid red;
}

</style>